import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BarChartIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bar_chart"}/>
}
